import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { brand, text, bg } from '../theme/colors';
import WelcomeExplainer from '../components/landing/WelcomeExplainer';

export default function WhatIsEqayaPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <WelcomeExplainer />

      {/* Final CTA */}
      <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: bg.paper, textAlign: 'center' }}>
        <Container maxWidth="sm">
          <Typography variant="h4" sx={{ fontWeight: 800, color: text.primary, mb: 2 }}>
            Ready to build with confidence?
          </Typography>
          <Typography sx={{ color: text.secondary, fontSize: '1.05rem', lineHeight: 1.7, mb: 4 }}>
            Join the platform connecting diaspora families with construction professionals in Zimbabwe — one milestone at a time.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/register')}
              sx={{
                bgcolor: brand.accent,
                color: 'white',
                fontWeight: 700,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1rem',
                '&:hover': {
                  bgcolor: '#b45309',
                  transform: 'translateY(-2px)',
                },
                transition: 'background-color 0.2s, transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1)',
              }}
            >
              Get Started
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate('/login')}
              sx={{
                borderColor: brand.primary,
                color: brand.primary,
                fontWeight: 600,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1rem',
                '&:hover': {
                  borderColor: brand.primaryDark,
                  bgcolor: 'rgba(13, 148, 136, 0.04)',
                },
              }}
            >
              Login
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
